module.exports = __webpack_public_path__ + "static/img/PF.f4ce7155.svg";